/* Sizes and data states shared by the dashboard widgets. */

import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { HEADER_H } from './model';
import { BodyNote, type FrameProps } from './WidgetFrame';
import { LoadingBlock } from '../components/Spinner';

/** The body's size in pixels (inside the border and below the header). */
export const bodySize = (p: FrameProps) => ({ width: p.width - 2, height: p.height - 2 - (p.widget.cfg.hdr ? HEADER_H : 0) });

/** The common states of a Statistics-backed widget; null when the data is there to draw. */
export function useDataState(): (s: { error: string | null; noAccess: boolean; hasData: boolean; reload: () => void }) => ReactNode | null {
  const { t } = useTranslation('dashboardWidgets');
  return (s) => {
    if (s.noAccess) return <BodyNote icon="lock">{t('widget.noAccess')}</BodyNote>;
    if (s.error) return <BodyNote icon="alert-circle" action={{ label: t('widget.retry'), onClick: s.reload }}>{t('widget.loadError')}</BodyNote>;
    if (!s.hasData) return <LoadingBlock pad="0" size={20} label={t('widget.loading')} style={{ flex: 1, minHeight: 0 }} />;
    return null;
  };
}
